import { resolveMemberPhotoUrl } from './upload-member-photo';

// Module-scoped in-memory cache keyed by `workspaceId:mediaId`.
// Stores the Promise itself so concurrent mounts coalesce into one request.
// Cleared automatically on browser refresh (module re-initialises).
//
// Entries are evicted just before the presigned URL's 900 s server-side expiry
// so the next render gets a fresh URL instead of a broken link. Null/failed
// resolutions are evicted immediately so transient errors can be retried.
const cache = new Map<string, Promise<string | null>>();
const CACHE_TTL_MS = 840_000; // 14 min — safely inside the 900 s read URL TTL

export function resolveAvatarUrl(workspaceId: string, mediaId: string): Promise<string | null> {
  const key = `${workspaceId}:${mediaId}`;
  const hit = cache.get(key);

  if (hit !== undefined) return hit;

  const promise = resolveMemberPhotoUrl(workspaceId, mediaId).then((url) => {
    if (url === null) {
      cache.delete(key);
    } else {
      setTimeout(() => cache.delete(key), CACHE_TTL_MS);
    }

    return url;
  });

  cache.set(key, promise);

  return promise;
}
